import { ApiClient } from '../../../api/ApiClient';
import { waitForOperation } from '../../../api/endpoints/operations';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { AccountModel } from '../../account/AccountModel';
import { templateCreatePopup, TemplateCreatePopupAction } from '../../dashboard/templates/popups/TemplateCreatePopup';
import { AlertHub } from '../../packages/alerts/AlertHub';
import { PassportModel } from '../../PassportModel';
import { busyPopup } from '../../popups/BusyPopup';
import { PopupManager } from '../../popups/PopupManager';
import { BoardInfo } from '../BoardInfo';
import { EditorModeInfo } from '../EditorModeInfo';
import { EditorSession } from '../EditorSession';
import { DesignMode } from './DesignMode';
import { publishPopup } from './PublishNewPopup';
import { publishSuccessPopup } from './PublishSuccessPopup';

export const switchToDesignMode = defineCommand(
    'switchToDesignMode',
    'Switch To: Design Mode',
    r => {

        const session = r.call(EditorSession);
        session.update(EditorModeInfo, DesignMode);
    }
);

export const boardPublish = defineCommand(
    'boardPublish',
    'Board: Publish As Template',
    async r => {

        const account = r.call(AccountModel);
        const api = r.call(ApiClient);
        const version = account.settings['dashboard.version'] || 'legacy';
        const alerts = r.call(AlertHub);
        const passport = r.call(PassportModel);
        const popups = r.call(PopupManager);
        const session = r.call(EditorSession);

        if (passport.verify('da:write')) {
            if (version === 'next') {
                // Force remove thumbUrl get it to regenerate
                const { thumbUrl: _, ...board } = session.get(BoardInfo);
                const { data: result } = await popups.invoke(templateCreatePopup(board));
                if (Array.isArray(result)) {
                    const [action, arg] = result as TemplateCreatePopupAction;
                    if (action === 'complete' && arg.executionId) {
                        await popups.invoke(busyPopup(
                            async () => {
                                await waitForOperation(api, arg.executionId);
                            }
                        ));
                        await popups.invoke(publishSuccessPopup());
                    }
                }
            }
            else {
                const { actioned, data } = await popups.invoke(publishPopup());
                if (actioned && data) {
                    await popups.invoke(publishSuccessPopup(data));
                }
            }
        }
        else {
            alerts.invoke({
                type: 'error',
                body: 'Sorry, as a guest in this account you do not have permission to publish templates!',
                delay: 0,
            });
        }

    }
);
